<div class="xl:flex" *ngIf="ticket">
    <div class="xl:flex-1">
        <section class="flex-center flex flex-col justify-center md:justify-start" *ngIf="showQrTicket">
            <rwidget-ticket-qr *ngIf="ticket" [ticket]="ticket" (qrClick)="qrClick()"></rwidget-ticket-qr>
        </section>
        <section
            class="flex-align-center px-15 flex w-full justify-center py-12"
            *ngIf="isHistoryTicket && env.HISTORY_TICKET_SHOW_STATUS">
            <div
                class="flex-align-center flex h-64 w-64 flex-col justify-center rounded-lg border border-solid bg-[#F2F2F2] dark:bg-contrast-black">
                <div class="text-sm font-semibold uppercase text-danger" *ngIf="isTicketRefunded()">
                    {{ 'TICKET_REFUNDED' | translate }}
                </div>
                <ng-container *ngIf="!isTicketRefunded()">
                    <div
                        class="text-sm font-semibold uppercase text-danger dark:text-contrast-yellow"
                        *ngIf="ticket.validated">
                        {{ 'TICKET_USED' | translate }}
                    </div>
                    <div
                        class="text-sm font-semibold uppercase text-danger dark:text-contrast-yellow"
                        *ngIf="ticket.status?.trim() === 'N'">
                        {{ 'RIDE_STATUS_CANCELLED' | translate }}
                    </div>
                    <ng-container *ngIf="!ticket.validated && !isCanceledTicket">
                        <div class="mb-4 text-sm font-semibold uppercase text-danger dark:text-contrast-yellow">
                            {{ 'TICKET_EXPIRED' | translate }}
                        </div>
                        <div class="text-sm font-semibold uppercase text-danger dark:text-contrast-yellow">
                            {{
                                ticket.ending
                                    | formatTimeZone
                                        : env.PERIOD_TICKET_DATE_FORMAT
                                        : env.TIMEZONE
                                        : null
                                        : null
                                        : false
                                        : ticket
                            }}
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </section>
        <section class="border-b border-solid border-black border-opacity-10 py-4 dark:border-contrast-yellow">
            <div class="mb-9 rounded-lg bg-[#5E5E5E]" *ngIf="ticket.loaned">
                <div class="flex items-center justify-between p-4">
                    <div class="text-base leading-5 text-white dark:text-contrast-yellow">
                        <p>
                            {{ (ticket.isOwner ? 'LEND_TICKET_DESCRIPTION' : 'BORROWED') | translate }}
                            {{ ticket.isOwner ? ticket.lenderEmail : ticket.email }}
                        </p>
                        <p>
                            {{ 'UNTIL' | translate }}
                            {{
                                env.SHOW_SELECTOR_TIME_LEND_TICKET
                                    ? formattedDate
                                    : (ticket.loanedUntil | formatTimeZone: dateTimeFormat : timezone)
                            }}
                        </p>
                    </div>
                    <button
                        class="btn link--no-line link--no-hover ml-4 w-24 bg-white px-2"
                        *ngIf="!env.SHOW_SELECTOR_TIME_LEND_TICKET"
                        (click)="returnLendTicket()">
                        {{ (ticket.isOwner ? 'REQUEST_RETURN' : 'RETURN_TICKET') | translate }}
                    </button>
                </div>
            </div>
            <h2
                class="vl-app-light:text-gray-dark sr-app-light:text-gray-dark text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                {{ 'CARD_STATUS_TICKET' | translate }}
            </h2>
            <h1
                class="vl-app-light:text-black sr-app-light:text-black pt-2 text-base font-normal dark:text-contrast-yellow">
                {{ ticketTitle$ | async }}
            </h1>
            <p
                class="vl-app-light:text-black sr-app-light:text-black mb-4 text-xs font-medium dark:text-contrast-yellow"
                *ngIf="ticket.cardType !== cardType.GLOBAL">
                <ng-container *ngIf="isTicketRefunded(); else historyTicket">
                    <span *ngIf="env.SHOW_HISTORY_TICKET_REFUND_DATES; else refundedOrCanceledTextOnly">
                        {{ 'TICKET_REFUNDED_TEXT' | translate }}
                        <ng-container *ngTemplateOutlet="refundedOrCanceledDate"></ng-container>
                    </span>
                    <ng-template #refundedOrCanceledTextOnly>
                        <span class="vl-app-light-dark:hidden">
                            {{ 'TICKET_REFUNDED' | translate }}
                        </span>
                    </ng-template>
                </ng-container>
                <ng-template #historyTicket>
                    <ng-container *ngIf="isHistoryTicket && env.SHOW_TICKET_HISTORY_NOTE; else bookletOrExpiring">
                        <ng-container *ngIf="!ticket.validated; else activeAfterValidation">
                            <ng-container *ngIf="isCanceledTicket; else expired">
                                <span *ngIf="env.SHOW_HISTORY_TICKET_CANCELED_DATES; else refundedOrCanceledTextOnly">
                                    {{ 'TICKET_CANCELLED_TEXT' | translate }}
                                    <ng-container *ngTemplateOutlet="refundedOrCanceledDate"></ng-container>
                                </span>
                                <ng-template #refundedOrCanceledTextOnly>
                                    <span class="vl-app-light-dark:hidden">
                                        {{ 'CANCELLED_DESCRIPTION' | translate }}
                                    </span>
                                </ng-template>
                            </ng-container>
                            <ng-template #expired>
                                <div class="flex-column flex">
                                    <span *ngIf="!!ticket.bookletEnding || hasFixedValidityRange(ticket)">
                                        <ng-container *ngTemplateOutlet="bookletValidityRange"></ng-container>
                                    </span>
                                    <span class="vl-app-light-dark:hidden">{{ 'EXPIRED' | translate }}</span>
                                </div>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template #bookletOrExpiring>
                    <ng-container *ngIf="ticket.bookletEnding || ticket.expiredAt; else activeAfterValidation">
                        <ng-container *ngIf="isRecentlyUsed; else notRecentlyUsed">
                            <ng-container *ngTemplateOutlet="ticketValidityRange"></ng-container>
                        </ng-container>
                        <ng-template #notRecentlyUsed>
                            <ng-container *ngIf="env?.TICKET_DETAILS_VALIDITY_RANGE_ONLY; else withExpireText">
                                <ng-container *ngIf="ticket.units === TEN_TRIP_TICKET_UNITS">
                                    <ng-container *ngTemplateOutlet="withExpireText"></ng-container>
                                </ng-container>
                                <ng-container *ngIf="ticket.units !== TEN_TRIP_TICKET_UNITS">
                                    <ng-container
                                        *ngIf="
                                            (ticket.units === 0 && !ticket.validated) || !ticket.activated;
                                            else activeOrValidated
                                        ">
                                        <span *ngIf="ticket.initialUnits > 1 && ticket.activated">
                                            {{
                                                ticket.timestamp
                                                    | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : env.TIMEZONE
                                            }}
                                            —
                                            {{
                                                ticket.bookletEnding
                                                    | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : env.TIMEZONE
                                            }}
                                        </span>

                                        <span *ngIf="ticket.initialUnits === 1">
                                            {{ 'ACTIVE_AFTER_FIRST_VALIDATION_NO_LATER_THAN' | translate }}
                                            {{
                                                ticket.bookletEnding || ticket.expiredAt
                                                    | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : env.TIMEZONE
                                            }}
                                        </span>
                                    </ng-container>

                                    <ng-template #activeOrValidated>
                                        <ng-container *ngTemplateOutlet="ticketValidityRange"></ng-container>
                                    </ng-template>
                                </ng-container>
                            </ng-container>
                            <ng-template #withExpireText>
                                <ng-container *ngIf="hasFixedValidityRange(ticket); else defaultExpireText">
                                    <ng-container *ngTemplateOutlet="ticketValidityRange"></ng-container>
                                </ng-container>
                                <ng-template #defaultExpireText>
                                    {{ 'EXPIRES_ON' | translate }}
                                    {{
                                        ticket.bookletEnding || ticket.expiredAt
                                            | formatTimeZone: expireDateTimeFormat : env.TIMEZONE
                                    }}
                                </ng-template>
                            </ng-template>
                        </ng-template>
                    </ng-container>
                </ng-template>
                <ng-template #activeAfterValidation>
                    <ng-container *ngIf="hasFixedValidityRange(ticket); else dynamicValidityRange">
                        {{ fixedValidityRangeStart(ticket) | date: 'dd.MM.yyyy HH:mm' }} -
                        {{ fixedValidityRangeEnd(ticket) | date: 'dd.MM.yyyy HH:mm' }}
                    </ng-container>
                    <ng-template #dynamicValidityRange>
                        <ng-container *ngIf="useUnifiedTicketValidityDisplay; else legacyActiveAfterValidation">
                            <ng-container *ngIf="ticket.starting && ticket.cardType !== 'Q'; else qrTicketUnified">
                                {{ [ticket.starting, ticket.ending] | ridangoDateTime: ridangoDateTimeOptions(ticket) }}
                            </ng-container>
                            <ng-template #qrTicketUnified>
                                <ng-container *ngIf="showTravellerQrTicketSummary; else activeQrTicketRange">
                                    {{ 'TICKET_SUMMARY_V2_TRAVELLER_QR_TICKET' | translate }}
                                </ng-container>

                                <ng-template #activeQrTicketRange>
                                    <ng-container *ngIf="ticket.starting && ticket.ending">
                                        <ng-container
                                            *ngIf="shouldUseDateTimeForQrTicket(ticket); else qrUnifiedRangeDefault">
                                            {{ ticket.starting | formatTimeZone: primaryDateTimeFormat : timezone }} -
                                            {{ ticket.ending | formatTimeZone: primaryDateTimeFormat : timezone }}
                                        </ng-container>

                                        <ng-template #qrUnifiedRangeDefault>
                                            {{
                                                [ticket.starting, ticket.ending]
                                                    | ridangoDateTime: ridangoDateTimeOptions(ticket)
                                            }}
                                        </ng-template>
                                    </ng-container>

                                    <ng-container *ngIf="ticket.starting && !ticket.ending">
                                        {{ ticket.starting | ridangoDateTime: ridangoDateTimeOptions(ticket) }}
                                    </ng-container>
                                </ng-template>
                            </ng-template>
                        </ng-container>
                    </ng-template>
                    <ng-template #legacyActiveAfterValidation>
                        <ng-container *ngIf="ticket.starting && ticket.cardType !== 'Q'; else qrTicket">
                            {{ ticket.starting | formatTimeZone: dateTimeFormat : timezone }}
                            -
                            {{ adjustedEndingDate$ | async | formatTimeZone: dateTimeFormat : timezone }}
                        </ng-container>
                        <ng-template #qrTicket>
                            <ng-container *ngIf="showTravellerQrTicketSummary; else activeLegacyQrTicketRange">
                                {{ 'TICKET_SUMMARY_V2_TRAVELLER_QR_TICKET' | translate }}
                            </ng-container>

                            <ng-template #activeLegacyQrTicketRange>
                                <ng-container *ngIf="ticket.starting">
                                    {{
                                        ticket.starting
                                            | formatTimeZone
                                                : (shouldUseDateTimeForQrTicket(ticket)
                                                      ? primaryDateTimeFormat
                                                      : dateTimeFormat)
                                                : timezone
                                    }}
                                    -
                                </ng-container>

                                {{
                                    ticket.ending
                                        | formatTimeZone
                                            : (shouldUseDateTimeForQrTicket(ticket)
                                                  ? primaryDateTimeFormat
                                                  : dateTimeFormat)
                                            : timezone
                                            : null
                                            : null
                                            : false
                                            : ticket
                                }}
                            </ng-template>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </p>
            <ng-container *ngIf="ticket.initialUnits > 1">
                <div
                    class="vl-app-light:text-black sr-app-light:text-black flex-column mb-4 flex text-xs font-medium dark:text-contrast-yellow">
                    <span
                        *ngIf="
                            !ticket.activated &&
                            (ticket.bookletEnding || ticket.expiredAt) &&
                            ticket.units < TEN_TRIP_TICKET_UNITS
                        "
                        >{{ 'TICKET_MUST_BE_USED_BY_END_OFF' | translate }}
                        {{
                            ticket.bookletEnding || ticket.expiredAt
                                | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : env.TIMEZONE
                        }}</span
                    >
                    <span>{{ 'TICKET_SUMMARY_V2_TICKETS_REMAINING' | translate }}: {{ ticket.units }}</span>
                </div>
            </ng-container>
            <ng-container *ngIf="!env.TICKET_DETAILED_INFORMATION">
                <ng-container *ngIf="ticket.startZone && ticket.endZone">
                    <h2 class="text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                        {{ 'TICKET_SUMMARY_V2_ZONE' | translate }}
                    </h2>
                    <h1 class="pt-2 text-base font-normal">{{ ticket.startZone.name }}</h1>
                </ng-container>
                <ng-container [ngSwitch]="ticket.cardType">
                    <ng-container *ngSwitchCase="'Q'">
                        <h2 class="text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                            {{ 'LOCAL_LABEL_EMAIL' | translate }}
                        </h2>
                        <h1 class="pt-2 text-base font-normal">{{ ticket.email }}</h1>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <h2
                            class="text-xs text-gray-500 dark:text-contrast-yellow"
                            *ngIf="ticket.cardType !== cardType.GLOBAL">
                            {{ 'CARD_NUMBER' | translate }}
                        </h2>
                        <h1 class="pt-2 text-base font-normal">
                            {{
                                ticket.cardType === TravelCardType.BankCard
                                    ? (ticket.emvCardScheme?.toLocaleLowerCase() || '') +
                                      ' ' +
                                      (ticket.maskedEmvCardPan || '-')
                                    : ticket.cardNumber || ticket.cardId
                            }}
                        </h1>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="env.TICKET_DETAILED_INFORMATION">
                <h2 class="text-gray-dark text-gray-dark text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                    {{ 'TICKET_SUMMARY_V2_TYPE' | translate }}
                </h2>

                <div class="flex justify-between">
                    <h1 class="pt-2 text-base font-medium text-black dark:text-contrast-yellow">
                        {{ ticket.startZoneName }}
                        <ng-container
                            *ngIf="
                                ticket.startZoneName &&
                                ticket.endZoneName &&
                                ticket.startZoneName !== ticket.endZoneName
                            ">
                            , {{ ticket.endZoneName }}
                        </ng-container>
                        <ng-container *ngIf="!ticket.startZoneName && !ticket.endZoneName">
                            {{ 'TICKET_SUMMARY_V2_ZONE_COUNTY' | translate }}
                        </ng-container>
                    </h1>
                    <ion-button
                        class="my-0 h-auto text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
                        *ngIf="(isOnline$ | async) === true"
                        [attr.aria-label]="'TICKET_SUMMARY_V2_ZONE_MAP' | translate"
                        (click)="openZoneMap()"
                        fill="clear">
                        {{ 'TICKET_SUMMARY_V2_ZONE_MAP' | translate }}
                    </ion-button>
                </div>
                <h2 class="text-gray-dark pt-4 text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                    {{ 'TICKET_SUMMARY_V2_CARD_NUMBER' | translate }}
                </h2>
                <h1 class="pb-4 pt-2 text-base font-medium text-black dark:text-contrast-yellow">
                    {{
                        ticket.cardType === TravelCardType.BankCard
                            ? (ticket.emvCardScheme?.toLocaleLowerCase() || '') + ' ' + (ticket.maskedEmvCardPan || '-')
                            : ticket.cardId
                    }}
                </h1>

                <ng-container *ngIf="!isCanceledTicket">
                    <h2
                        class="text-gray-dark text-gray-dark text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                        {{ 'TICKET_SUMMARY_V2_NOTIFICATION' | translate }}
                    </h2>
                    <h1 class="pb-4 pt-2 text-base font-medium text-black dark:text-contrast-yellow">
                        {{ 'TICKET_SUMMARY_V2_NOTIFICATION_WHEN_ENDING' | translate }}
                    </h1>
                </ng-container>
            </ng-container>
        </section>
        <ng-container *ngIf="ticket.cardType !== cardType.GLOBAL && ticketPriceForDisplay !== null">
            <section class="py-4 text-2xl font-bold">
                {{ ticketPriceForDisplay | moneyFormat }} {{ currency | translate }}
            </section>
        </ng-container>
        <section *ngIf="isManualActivationEnabled(ticket) && !env.PURCHASE_FLOW.HIDE_INLINE_MANUAL_ACTIVATION_BUTTON">
            <button
                class="btn-primary btn-primary--sharp-dark jk-light:text-white my-4 box-border w-full bg-secondary p-4 text-center text-primary dark:text-contrast-black"
                (click)="ticketService.activateManually(ticket.id ?? ticket.docNum)">
                {{ 'TICKET_ACTIVATE_MANUAL_BTN' | translate }}
            </button>
        </section>

        <section class="sr-app-light:pt-2 py-4 font-bold" *ngIf="(isOnline$ | async) === true">
            <button *ngFor="let b of ticketBtns" [ngClass]="b.cssClass" [disabled]="b.disabled" (click)="b.handler()">
                {{ b.text }}
            </button>
        </section>
    </div>
</div>

<ng-template #ticketValidityRange>
    <ng-container *ngIf="hasFixedValidityRange(ticket); else dynamicTicketValidityRange">
        {{ fixedValidityRangeStart(ticket) | date: 'dd.MM.yyyy HH:mm' }} -
        {{ fixedValidityRangeEnd(ticket) | date: 'dd.MM.yyyy HH:mm' }}
    </ng-container>
    <ng-template #dynamicTicketValidityRange>
        <ng-container *ngIf="useUnifiedTicketValidityDisplay; else legacyTicketValidityRange">
            {{
                [standardTicketRangeStart(ticket), standardTicketRangeEnd(ticket)]
                    | ridangoDateTime: ridangoDateTimeOptions(ticket)
            }}
        </ng-container>
        <ng-template #legacyTicketValidityRange>
            {{ ticket.starting || ticket.timestamp | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : env.TIMEZONE }}
            —
            {{
                ticket.ending || ticket.bookletEnding || ticket.expiredAt
                    | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : env.TIMEZONE
            }}
        </ng-template>
    </ng-template>
</ng-template>

<ng-template #bookletValidityRange>
    <ng-container *ngIf="hasFixedValidityRange(ticket); else dynamicBookletValidityRange">
        {{ fixedValidityRangeStart(ticket) | date: 'dd.MM.yyyy HH:mm' }} -
        {{ fixedValidityRangeEnd(ticket) | date: 'dd.MM.yyyy HH:mm' }}
    </ng-container>
    <ng-template #dynamicBookletValidityRange>
        <ng-container *ngIf="useUnifiedTicketValidityDisplay; else legacyBookletValidityRange">
            {{ [bookletRangeStart(ticket), bookletRangeEnd(ticket)] | ridangoDateTime: ridangoDateTimeOptions(ticket) }}
        </ng-container>
        <ng-template #legacyBookletValidityRange>
            {{ ticket.timestamp || ticket.starting | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : env.TIMEZONE }}
            —
            {{
                ticket.bookletEnding || ticket.ending || ticket.expiredAt
                    | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : env.TIMEZONE
            }}
        </ng-template>
    </ng-template>
</ng-template>

<ng-template #refundedOrCanceledDate>
    {{ ticket.timestamp | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : env.TIMEZONE }}
</ng-template>
